import { useDispatch, useSelector } from "react-redux";
import { useProperty } from "../../../PropertyContext";
import { fetchConnectivity, saveConnectivity } from "../../../Redux/Slices/connectivitySlice";
import swal from "sweetalert";
import { useState } from "react";

export const AddConectivity = () => {
    const { selectedProperty } = useProperty();
    const dispatch = useDispatch();
    const { connectivityList, loading } = useSelector(state => state.connectivity);

    const [placeName, setPlaceName] = useState("");
    const [distance, setDistance] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!placeName.trim() || !distance.trim()) {
            swal("Warning!", "Please fill all fields", "warning");
            return;
        }

        // ✅ SortOrder Logic (Same as Terms)
        const sortOrder =
            connectivityList && connectivityList.length > 0
                ? Math.max(...connectivityList.map(item => item.SortOrder)) + 1
                : 0;

        const postData = {
            PropertyID: selectedProperty.PropertyID,
            PlaceName: placeName,
            Distance: distance,
            SortOrder: sortOrder
        };

        try {
            const resultAction = await dispatch(saveConnectivity(postData));

            if (saveConnectivity.fulfilled.match(resultAction)) {

                await swal("Success!", "Connectivity Added Successfully", "success");

                // Refresh list
                dispatch(fetchConnectivity(selectedProperty.PropertyID));

                // Clear fields
                setPlaceName("");
                setDistance("");

                // ✅ Close Modal (Bootstrap 5 way)
                const modalElement = document.getElementById("Add-Connectivity");
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                modalInstance.hide();
            } else {
                swal("Error!", "Something went wrong", "error");
            }

        } catch (error) {
            swal("Error!", "Failed to save data", "error");
        }
    };

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12 mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Place"
                            value={placeName}
                            onChange={(e) => setPlaceName(e.target.value)}
                        />
                    </div>

                    <div className="col-md-12">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Distance"
                            value={distance}
                            onChange={(e) => setDistance(e.target.value)}
                        />
                    </div>

                    <div className="col-md-12">
                        <div className="text-end mt-3">
                            <button type="submit" className="btn btn-primary">
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}
